import { render } from "./dtedit.vue?vue&type=template&id=59bb03fa&scoped=true"
import script from "./dtedit.vue?vue&type=script&lang=js"
export * from "./dtedit.vue?vue&type=script&lang=js"

import "./dtedit.vue?vue&type=style&index=0&id=59bb03fa&lang=scss&scoped=true"
import "./dtedit.vue?vue&type=style&index=1&id=59bb03fa&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bb03fa"]])

export default __exports__